import './styles/index';
import { runAfterSessionData } from 'owa-delayed-initialization';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyInitializeErrorHandlerDevtools } from 'owa-exception-handler-devtools';
export { default as App } from './components/App';

runAfterSessionData(() => {
    if (
        process.env.NODE_ENV === 'dev' ||
        (isFeatureEnabled('fwk-devTools') && isFeatureEnabled('fwk-errorpopup'))
    ) {
        lazyInitializeErrorHandlerDevtools.importAndExecute();
    }
});

export { default as isAppPaneUnderlayExpanded } from './utils/isAppPaneUnderlayExpanded';
export { default as isAppPaneUnderlayShrinkable } from './utils/isAppPaneUnderlayShrinkable';
